import { type Moment } from "moment"
import { type IBaseWithFiles } from "@/interfaces/api/base-with-files.interface"
import { type IProject } from "@/interfaces/api/project.interface"

export enum SurchargeTransactionTypes {
  PERCENTAGE = 1,
  FLAT = 2,
  PER_UNIT = 3
}

export interface ITransaction extends IBaseWithFiles {
  instruction: string
  project: IProject
  date: Moment
  isSurchargeFor: string | undefined
  quantity: string | undefined
  unitPrice: string | undefined
  sortIndex: number
  hasCustomUnitPrice: boolean
  comment: string | undefined
  surchargeType: SurchargeTransactionTypes | undefined

  // Annotated
  instructionReference: string
  instructionDate?: Moment
  orderReference: string
  projectExecutorFullName: string
  surchargeDescription: string | undefined
  surchargePercent: string | undefined
  surchargePerUnit: string | undefined
  surchargeFlat: string | undefined
}
